import {Exam} from '@/core/api/room.exam.api';

export default {
	async getExamInfo({ dispatch, commit, state, rootState, rootGetters }) {
		return await Exam.getExamInfo();
	},
	async startExam({ dispatch, commit, state, rootState, rootGetters }, params) {
		params = {
			bankExamId: rootState.testbank.testbankExam.bankExamId,
			examDuration: params.examDuration || 1000,
		};

		if (state.roomExam.roomExamId) {
			throw new Error('EXAM_ALREADY_STARTED');
		}

		dispatch('room/changeRoomMode', { roomMode: 'exam' }, { root: true });
		return await Exam.startExam(params);
	},
	async endExam({ dispatch, commit, state, rootState, rootGetters }) {
		const params = {
			roomExamId: state.roomExam.roomExamId,
		}

		if (!params.roomExamId) {
			return;
		}

		dispatch('room/changeRoomMode', { roomMode: 'call' }, { root: true });
		return await Exam.endExam(params);
	},
	async createUserExam({ dispatch, commit, state, rootState, rootGetters }, params) {
		params = {
			...params,
			roomExamId: state.roomExam.roomExamId,
			username: rootGetters['user/me'].username,
		}

		return await Exam.createUserExam(params);
	},
	async submitUserAnswers({ dispatch, commit, state, rootState, rootGetters }, params) {
		params = {
			...params,
			roomExamId: state.roomExam.roomExamId,
			userId: rootGetters['user/me'].userId,
			examTypeQuiz: state.roomExam.examType === 'QUIZ',
		}
		return await Exam.submitUserAnswers(params);
	},
	async completeUserExam({ dispatch, commit, state, rootState, rootGetters }, params) {
		params = {
			...params,
			roomExamId: state.roomExam.roomExamId,
			userId: rootGetters['user/me'].userId,
			examTypeQuiz: state.roomExam.examType === 'QUIZ',
		}
		return await Exam.completeUserExam(params);
	},
	async getAllUserAnswers({ dispatch, commit, state, rootState, rootGetters }, params) {
		return await Exam.getAllUserAnswers(params);
	},
	async getUserAnswers({ dispatch, commit, state, rootState, rootGetters }, params) {
		return await Exam.getUserAnswers(params);
	},
}
